import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleRejectedByProfessionalsUseCaseInterface } from 'domain/usecases';

interface IRejectedByProfessionalsState {
  rejectedByProfessionals: HandleRejectedByProfessionalsUseCaseInterface.Result;
}

interface IPayloadRejectedByProfessionals
  extends PayloadAction<HandleRejectedByProfessionalsUseCaseInterface.Result> {}

const initialState: IRejectedByProfessionalsState = {
  rejectedByProfessionals: null,
};

export const RejectedByProfessionalsSlice = createSlice({
  name: 'rejected-by-professionals',
  initialState,
  reducers: {
    loadRejectedByProfessionals: (
      state,
      action: IPayloadRejectedByProfessionals,
    ) => {
      state.rejectedByProfessionals = action.payload;
    },
    clearRejectedByProfessionals: (state) => {
      state.rejectedByProfessionals = null;
    },
  },
});

export const { loadRejectedByProfessionals, clearRejectedByProfessionals } =
  RejectedByProfessionalsSlice.actions;

export default RejectedByProfessionalsSlice.reducer;
